import { INLINE_LINK } from '@/components/bedrock';
import { LocalizedLink as Link } from '@/components/LocalizedLink';
import { useT } from '@/core/I18nProvider';

import type { ReactElement } from 'react';

/**
 * The closing sections of `/trust/ai` — the related-documents cross-reference and
 * the contact section. Split from its page to keep that component under the
 * ~300-line ceiling (`.claude/rules/architecture.md`), following the
 * `TermsFooterSections` precedent in this directory. Purely presentational,
 * same keys, imports nothing back from its parent.
 */
export function AiComplianceFooterSections(): ReactElement {
  const { t } = useT();
  return (
    <>
      <section aria-labelledby="ai-related" className="mb-10">
        <h2
          id="ai-related"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('ai.related.heading')}
        </h2>
        <ul className="list-disc space-y-1 ps-6">
          <li>
            <Link className={INLINE_LINK} to="/trust/compliance">
              {t('ai.related.compliance.link')}
            </Link>{' '}
            {t('ai.related.compliance.desc')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/privacy">
              {t('ai.related.privacy.link')}
            </Link>{' '}
            {t('ai.related.privacy.desc')}
          </li>
          <li>
            <Link className={INLINE_LINK} to="/trust/security">
              {t('ai.related.security.link')}
            </Link>{' '}
            {t('ai.related.security.desc')}
          </li>
        </ul>
      </section>

      <section aria-labelledby="ai-contact">
        <h2
          id="ai-contact"
          className="mb-3 mt-11 scroll-mt-[calc(var(--bd-nav-h)+22px)] text-[1.45rem] font-semibold leading-[1.15] tracking-[-0.032em] text-[color:var(--bd-ink)]"
        >
          {t('ai.contact.heading')}
        </h2>
        <p>
          {t('ai.contact.body')}{' '}
          <a className={INLINE_LINK} href="mailto:admin@syncanix.com">
            admin@syncanix.com
          </a>
          .
        </p>
      </section>
    </>
  );
}
